import { Layout, MessageSimulationSystem } from "components"
export const MessageSimulation = () => {
 return (
  <Layout>
   <MessageSimulationSystem />
  </Layout>
 )
}
